let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i6MOT")).then(() => parcelRequire('eOS0l'));